import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, writeBatch } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBiUSYcHE2Zsp8Ma6RCyHS-83xZrGlC2T8",
  authDomain: "the-inner-network.firebaseapp.com",
  projectId: "the-inner-network",
  storageBucket: "the-inner-network.firebasestorage.app",
  messagingSenderId: "913843678632",
  appId: "1:913843678632:web:c5b9e1d7f5cdc715e6019d"
};

// Initialize primary app (for logged-in admin session)
const firebaseApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);
const functions = getFunctions(firebaseApp);

// Initialize secondary app for creating users without affecting admin login
const secondaryApp =
  getApps().find(app => app.name === "SECONDARY") ||
  initializeApp(firebaseConfig, "SECONDARY");
const secondaryAuth = getAuth(secondaryApp);

export { firebaseApp, auth, db, writeBatch, storage, functions, secondaryAuth };